export const FOOTER_CONTACTS = [
	{
		title: {
			default: "Colombia y América Latina",
			translationId: "contact.region.colombia_latam",
		},
		emails: [
			{
				contactName: null,
				email: "contacto@makemake.com.co",
			},
		],
		contactNumbers: [
			"(57) 350 236 7037",
			"(57) 350 201 1041",
		],
	},
	{
		title: {
			default: "Estados Unidos y Puerto Rico",
			translationId: "contact.region.usa_puerto_rico",
		},
		emails: [
			{
				contactName: null,
				email: "info@chinita.online",
			},
		],
		contactNumbers: ["+1 (310) 690 0297"],
		adresses: ["Chinita Compani LLC","8400 NW 36th Street Suite 450", "Miami. FL"],
	},
	// {
	// 	title: {
	// 		default: "Colombia y América Latina",
	// 		translationId: "contact.region.colombia_latam",
	// 	},
	// 	emails: [
	// 		{
	// 			contactName: null,
	// 			email: "contacto@makemake.com.co",
	// 		},
	// 	],
	// 	contactNumbers: [
	// 		"(57) 350 236 7037",
	// 		"(57) 350 201 1041",
	// 		"(57) 313 450 9992",
	// 		"+1 (800) 345-5946 ext 2241",
	// 	],
	// 	adresses: ["Cra 13 No. 33-74. Bogotá, Colombia"],
	// },
	// {
	// 	title: {
	// 		default: "Estados Unidos y Puerto Rico",
	// 		translationId: "contact.region.usa_puerto_rico",
	// 	},
	// 	emails: [
	// 		{
	// 			contactName: "Chinita Compani LLC",
	// 			email: "info@chinita.online",
	// 		},
	// 		{
	// 			contactName: null,
	// 			email: "contacto@makemake.com.co",
	// 		},
	// 	],
	// 	contactNumbers: ["+1 (310) 690 0297"],
	// 	adresses: ["8400 NW 36th Street Suite 450", "Miami. FL"],
	// },
	// {
	// 	title: {
	// 		default: "México",
	// 		translationId: "contact.region.mexico",
	// 	},
	// 	emails: [
	// 		{
	// 			contactName: null,
	// 			email: "contacto@infoestrategica.com",
	// 		},
	// 	],
	// 	contactNumbers: ["+52 55 90000210"],
	// 	adresses: [
	// 		"Montecito 38, Piso 4 Oficina 22,",
	// 		"Col. Nápoles, Benito Juárez, 03810",
	// 		"Ciudad de México, CDMX",
	// 	],
	// },
];
